import { playOptions, convertStreamTypeFromTaf, } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerPlayUrl = async (container, parameters) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    await player.playUrl({
        url: parameters.asset.url,
        licenseUrl: parameters.asset?.licenseUrl,
        fairPlayCertificateUrl: parameters.asset?.fairPlayCertificateUrl,
        streamType: convertStreamTypeFromTaf(parameters.asset.streamType),
    }, {
        ...playOptions(parameters.options),
    });
};
